<template>
  <b-container fluid class="friend-referrals">
    <!-- NAVBAR -->
    <b-row>
      <b-col class="header-nav-bar">
        <HeaderNavBar active-link="friend_referrals" />
      </b-col>
    </b-row>

    <!-- FRIENDS REFERRAL CONTENT -->
    <b-row class="body-padding">
      <b-col class="content">
        <b-container style="margin-right: 0rem; margin-left: 0rem; ">
          <b-row align-v="center" class="friend-referral-section">
            <!-- <PremiumContent :customerInfo="customerInfo" /> -->

            <!-- SECTION - GET A FREE MONTH -->
            <div>
              <b-card bg-variant="light" class="text-center">
                <img
                  src="../../../assets/images/icon-thank-you.png"
                  alt="Get a free month"
                />

                <b-card-text>
                  <span>Get a free month! </span>
                </b-card-text>
                <b-card-text
                  >We'll give you a free month for each invited friend who
                  becomes a paying client. <br />
                  You must have an active subscription to receive rewards!
                </b-card-text>

                <b-card-text
                  ><b>Your Personal Link</b></b-card-text
                >
                <!-- Link Button to copy the personal link -->
                <div class="input-section">
                  <b-input-group class="mt-3">
                    <b-form-input
                      class="link-input"
                      readonly
                      ref="clone"
                      v-on:focus="$event.target.select()"
                      :value="personalLink"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        variant="outline-success"
                        class="button-personal-link"
                        @click="copy"
                        >Copy</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>

                <b-card-text
                  ><b>Text Ready For You To Share</b></b-card-text
                >

                <b-card-text
                  >"Dropsmart - The Most Trusted Essential Oil Resource Center On The Planet.<br/><br/>
                  Dropsmart helps aromatherapy experts reach cutting-edge scientific references in seconds. This means that it saves you a massive amount of time and provides you with credible sources to quote from. It's a guide for you if you're preparing a lecture, working in a clinical environment, formulating a specific blend, creating your own products, taking care of your family and friends, or just experimenting with essential oils for fun."
                  </b-card-text
                >

                <b-card-text class="text-color-light"
                  >Share Your Link in Social Media</b-card-text
                >

                <b-link target="_blank" :href="sharedUrl" class="card-link"
                  ><FacebookIcon
                /></b-link>

                <b-link href="https://instagram.com" class="card-link"
                  ><InstagramIcon
                /></b-link>
              </b-card>
            </div>

            <!-- SECTION - REFER FRIENDS BY EMAIL -->
            <div>
              <p class="section-title"><span>Refer Friends by Email</span></p>
              <p>
                Your friends can create their account by following the link in the
                email.
              </p>
              <p class="drop-margin">
                Inform your friend's emails (maximum of 10 emails per round). Use a comma to separate them.
              </p>
              <b-form
                class="email-form"
                @submit.prevent="submitEmailsForm"
                method="post"
                ref="emailsForm"
              >
                <div>
                  <div class="input-section">
                    <b-input-group class="mt-3">
                      <b-form-textarea
                        class="emails-textarea"
                        v-model="$v.form.emails.$model"
                        id="textarea-email-state"
                        :state="validateState('emails')"
                      ></b-form-textarea>
                    </b-input-group>
                  </div>

                  <div class="checkbox-section">
                    <input
                      type="checkbox"
                      id="checkbox-1"
                      v-model="status"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                    />
                    I've got my friend's approval to send them this email.
                  </div>

                  <div class="toast-container-message">
                    <b-toast
                      title="Thank You!"
                      id="emailsSent"
                      variant="success"
                      static
                      solid
                      auto-hide-delay="7000"
                      no-close-button
                    >
                      {{ EmailWasSentMessage }}
                    </b-toast>
                    <b-toast
                      title="Sorry!"
                      id="emailsNotSent"
                      variant="danger"
                      static
                      solid
                      auto-hide-delay="7000"
                      no-close-button
                    >
                      {{ EmailWasntSentMessage }}
                    </b-toast>
                  </div>

                  <button
                    :disabled="!status"
                    class="button-emails-form"
                    type="submit"
                    id="submitButton"
                  >
                    <b-spinner small v-show="showLoad"></b-spinner>
                    <span class id="button-text" v-if="!showLoad"
                      >Send Invite</span
                    >
                  </button>
                </div>
              </b-form>
              <hr />
            </div>

            <!-- SECTION - REFERRAL HISTORY -->
            <div v-if="false">
              <p class="section-title">Referral History</p>
              <b-card bg-variant="light" class="text-center">
                <b-card-text> You haven't invited anyone yet.</b-card-text>
              </b-card>
            </div>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import HeaderNavBar from "@/components/private/my-account/HeaderNavBar.vue";
import FacebookIcon from "@/components/icons/FacebookIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import { BACKEND_URL } from "@/config.js";

export default {
  title: "Dropsmart - Friend Referrals",
  name: "FriendReferrals",
  props: {
    page: {
      default: "",
      type: String,
    },
  },
  mixins: [validationMixin],

  components: {
    HeaderNavBar,
    FacebookIcon,
    InstagramIcon,
  },
  validations: {
    form: {
      emails: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    let target = this.page ? this.page : "FriendReferrals";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  watch: {
    contactId: {
      immediate: true,
      handler() {
        this.fetchContactId();
      },
    },
  },
  data() {
    return {
      text: "https://partner.dropsmart.io/?orid=",
      contactId: "[ContactID]",
      customerInfo: null,
      form: {
        emails: "",
        customerName: JSON.parse(sessionStorage.getItem("customerInfo")).user
          .firstName,
      },
      status: false,
      showLoad: false,
      EmailWasSentMessage:
        "We'll send an email inviting your friends to become part of Dropsmart.",
      EmailWasntSentMessage:
        "Sorry, but we were unable to send your message now. Please, try again later.",
    };
  },

  computed: {
    personalLink() {
      return this.text + this.contactId;
    },
    sharedUrl() {
      const personalUrl = encodeURI(this.personalLink);
      const sharedUrl = `https://www.facebook.com/sharer/sharer.php?u=${personalUrl}`;
      return sharedUrl;
    }
  },
  methods: {
    copy() {
      this.$refs.clone.focus();
      document.execCommand("copy");
    },
    navigate(routeName) {
      this.content = routeName;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    fetchContactId() {
      var customerInfo = sessionStorage.getItem("customerInfo");
      if (!customerInfo) {
        console.error(
          "Customer is not logged in, fetching ContactID not allowed."
        );
        return;
      }

      customerInfo = JSON.parse(customerInfo);

      let customerId = customerInfo.user.id;
      let url = `${BACKEND_URL.Base}/customers/${customerId}/ontraport-data`;

      fetch(url, {
        method: "get",
        mode: "cors",
        headers: {
          Accept: "application/json",
          Authorization: customerInfo.token.token,
        },
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("failed to fetch contactID");
          }
        })
        .then((response) => {
          this.contactId = response.contactId;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
    },
    submitEmailsForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.showLoad = true;

      let customer = sessionStorage.getItem("customerInfo");
      var jwt = null;
      if (customer) {
        jwt = JSON.parse(customer).token.token;
      }
      let reqHeaders = { "Content-type": "application/json" };
      if (jwt) {
        reqHeaders["Authorization"] = jwt;
      }

      //adding the personal link to the form
      this.form.link = this.text + this.contactId;

      let jsonForm = JSON.stringify(this.form);

      console.log(jsonForm);

      let customerId = JSON.parse(customer).user.id;

      // const url = BACKEND_URL.FriendsEmailsForm;
      let url = `${BACKEND_URL.Base}/customers/${customerId}/friend-referral`;

      console.log("SUBMITING THE FORM " + url);

      fetch(url, {
        method: "POST",
        mode: "cors",
        body: jsonForm,
        headers: reqHeaders,
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            this.showLoad = false;
            this.$bvToast.show("emailsSent");
          } else {
            this.showLoad = false;
            this.$bvToast.show("emailsNotSent");
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .catch((error) => {
          this.showLoad = false;
          console.error(error);
        });

      // Reset some form values
      this.form.emails = "";
      this.status = false;
      // Reset/clear native browser form validation state
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.friend-referrals {
  .body-padding {
    padding-top: 100px;

    .content {
      padding: 0 12rem;

      .friend-referral-section {
        display: block;

        .card {
          border: none;
          border-radius: 0.9rem;
          margin-bottom: 2rem;

          img {
            max-height: 60px;
            margin-bottom: 1rem;
          }

          .card-text {
            span {
              font-size: 22px;
              font-weight: 700;
            }
          }

          .input-section {
            margin-bottom: 30px;

            .link-input {
              border: none;
              background-color: #ffffff;
            }
          }
        }
      }
    }
  }
}

.text-color-light {
  font-size: 0.9rem;
  color: #999999;
}

.card-link {
  svg {
    fill: #999999;
  }
  &:hover {
    color: #ee4586;
    svg {
      fill: #ee4586;
    }
  }
}

.section-title {
  font-size: 18px;
  font-weight: 700;
}

.drop-margin {
  margin-top: 2rem;
  margin-bottom: 0;
}

#textarea-email-state {
  resize: none;
  border-radius: 0.5rem;
}

hr {
  margin: 2rem 0;
}

.checkbox-section {
  margin: 2rem 0;
}

.form-checkbox {
  background-color: #9b59b6;
}

#checkbox-1 {
  accent-color: #28a745;
}

.email-form {
  max-width: 100%;
}

.toast-container-message {
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;

  #emailsSent.toast,
  #emailsNotSent.toast {
    margin: 2rem 0;
  }
}

.button-emails-form {
  background: #79b867;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  width: 30%;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 15px;
  line-height: 25px;
}

.button-emails-form:hover {
  background: #000000;
}

.button-emails-form:active,
.button-emails-form:focus {
  background: #000000;
  color: #ffffff;
  border-color: #000000;
  box-shadow: none;
  outline: none;
}

.button-emails-form:disabled {
  background-color: #999999;
  border: 1px solid #999999;
  color: white;
}
</style>
